export const faqByRole = {
  host: [
    {
      id: 1,
      question: "How do I create an event?",
      answer: [
        'Tap "Create Event", fill in event details (title, date/time, attire, images, tickets, refund policy e.t.c) and publish',
      ],
      images: [
        "/images/slide1.png",
        "/images/slide2.png",
        "/images/slide3.png",
      ],
    },
    {
      id: 2,
      question: "Can I edit event after creating it?",
      answer: ["Yes, you can edit all event details after it has been created"],
      images: ["/images/slide4.png", "/images/slide5.png"],
    },
    {
      id: 3,
      question: "How do I invite guests to my event?",
      answer: [
        "There is an invite link on the event details page that can be shared with guests on any platform.",
      ],
      images: ["/images/slide6.png", "/images/slide7.png"],
    },
    {
      id: 4,
      question: "What fees do I pay as a host?",
      answer: [
        "10% on all tickets sold. No charges on attire/clothing or cash gift",
      ],
    },
    {
      id: 5,
      question: "Can I upload multiple dates and times for one event?",
      answer: [
        "Yes, you can set multiple sessions or dates when creating your event.",
      ],
      images: ["/images/slide8.png", "/images/slide9.png"],
    },
    {
      id: 6,
      question: "How do I manage ticket sales?",
      answer: [
        "From your dashboard, you can track ticket sales and guests lists",
      ],
    },
    {
      id: 7,
      question: "Can I set a refund policy?",
      answer: ["Yes, hosts can specify refund timelines during event setup"],
    },
    {
      id: 8,
      question: "When do I receive my funds?",
      answer: [
        "Payments (Event attire sales, ticket sales, and gifts) are transferred to you after deductions, in your account given to the support team.",
      ],
    },
  ],

  guest: [
    {
      id: 1,
      question: "How do I buy tickets?",
      answer: [
        "Select the event, choose your ticket type and quantity, and pay using your preferred payment method.",
      ],
      images: ["/images/slide14.png"],
    },
    {
      id: 2,
      question: "Do I pay extra charges as a guest?",
      answer: [
        "Guests do not pay charges on tickets or cash gifts, but a 5% fee applies to clothing and paraphernalia.",
      ],
    },
    {
      id: 3,
      question: "Can I get a refund if I can't attend?",
      answer: [
        "Yes. Refunds are subject to the event’s refund policy set by the host.",
      ],
      images: ["/images/slide15.png"],
    },
    {
      id: 4,
      question: "How do I send a cash gift to the host?",
      answer: [
        "Use the “Gift” button on the event page, select your amount, and complete the payment.",
      ],
      images: ["/images/slide16.png"],
    },
    {
      id: 5,
      question: "My payment failed but I was charged, what do I do?",
      answer: [
        "The system automatically reverses failed transactions.",
        "If you don’t receive a refund within 24–48 hours, contact support with your payment reference.",
      ],
    },
    {
      id: 6,
      question: "How secure are my payments?",
      answer: [
        "All payments are processed through trusted payment gateways, and your details are encrypted for security.",
      ],
      images: ["/images/slide17.png"],
    },
  ],

  usher: [
    {
      id: 1,
      question: "Who is an Usher?",
      answer: [
        "An usher is a trusted event assistant invited by the event host to help manage guest check-ins on the event day.",
      ],
    },
    {
      id: 2,
      question: "How do I become an Usher for an event?",
      answer: [
        "You can only join an event as an usher using an invite code shared by the event host.",
        "Without this code, you won’t be able to access the event.",
      ],
      images: ["/images/slide10.jpg"],
    },
    {
      id: 3,
      question: "Do I need the host's approval?",
      answer: [
        "Yes. After joining an event with the invite code, the host must approve you before you can scan guests in.",
        "You won't be able to perform any check-ins until approval is granted.",
      ],
      images: ["/images/slide11.png"],
    },
    {
      id: 4,
      question: "What can I do as an Usher?",
      answer: [
        "As an usher, you can:",
        "• Scan guests’ tickets (QR codes) on the event day",
        "• Check guests in at the entrance",
        "• View the guest list for the event",
      ],
      images: ["/images/slide12.png"],
    },
    {
      id: 5,
      question: "Can I scan guests without approval?",
      answer: [
        "No. Host approval is mandatory before you can scan or check in any guest.",
      ],
    },
    {
      id: 6,
      question: "Can I see the guest list?",
      answer: [
        "Yes. You can view the list of guests attending the event, including their check-in status.",
      ],
      images: ["/images/slide13.png"],
    },
    {
      id: 7,
      question: "Can I edit event or guest details?",
      answer: [
        "No. Ushers do not have permission to edit event details or guest information.",
        "Your role is strictly for guest check-in and viewing the guest list.",
      ],
    },
    {
      id: 8,
      question: "Do I need to pay to be an Usher?",
      answer: [
        "No. Ushers do not need to make any payment to access or perform their duties on the app.",
      ],
    },
    {
      id: 9,
      question: "Can I scan the same ticket more than once?",
      answer: [
        "No. Each guest ticket can only be scanned once.",
        "If a ticket has already been used, the app will notify you to prevent duplicate entry.",
      ],
    },
    {
      id: 10,
      question: "Can I be an Usher for multiple events?",
      answer: [
        "Yes, as long as you receive an invite code and approval from the host for each event.",
      ],
    },
  ],
};
